// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveySessionPostRequest {
    'surveyId'?: number;
    'surveySourceId'?: number;
    'sourceSystemId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveySessionPostRequest>> = [
        {
            "name":     "surveyId",
            "baseName": "surveyId",
            "type":     "number"
        },
        {
            "name":     "surveySourceId",
            "baseName": "surveySourceId",
            "type":     "number"
        },
        {
            "name":     "sourceSystemId",
            "baseName": "sourceSystemId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SurveySessionPostRequest.attributeTypeMap;
    }
}
